import styled from "styled-components"

export const FlexContainerHorizontal = styled.div`
  display: flex;
  align-items: center;
`

export const FlexContainerVertical = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const Grid = styled.div`
  display: grid;
  grid-gap: 32px;
  grid-template-columns: 1fr;
 
  @media (max-width: 960px) {
    grid-template-columns: auto;
  }
`

export const OneColumnGrid = styled(Grid)`
  grid-template-columns: 1fr;
`

export const TwoColumnsGrid = styled(Grid)`
  grid-template-columns: 1fr 1fr;
`

export const ThreeColumnsGrid = styled(Grid)`
  grid-template-columns: 1fr 1fr 1fr;
`
